import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Divider } from '@material-ui/core';
const styles = {
  card: {
    minWidth: 275
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)'
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  }
};

function I3Card(props) {
  const classes = props.classes;
  const bull = React.createElement("span", {
    className: classes.bullet
  }, "\u2022");
  return React.createElement(Card, {
    className: classes.card
  }, React.createElement(CardContent, null, React.createElement(Typography, {
    className: classes.title,
    color: "textSecondary",
    gutterBottom: true
  }, "ESCRUTADO: 75%"), React.createElement(Divider, {
    variant: "inset"
  })), React.createElement(CardActions, null, React.createElement(Button, {
    size: "small"
  }, "Learn More")));
}

I3Card.propTypes = {
  classes: PropTypes.object.isRequired
};
export default withStyles(styles)(I3Card);